'use strict';

// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import euiPanelyta from 'v-components/euiPanelyta';
import { ssoFiltreraDatatable } from 'v-components/ssoFiltreraDatatable';
import { ssoTogglaRaderIDatatable } from 'v-components/ssoTogglaRaderIDatatable';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(

// Övrigt:
import { ssoTooltips } from 'ssoTooltips';
import { ssoPersaldoDatatable } from 'datatables/ssoPersaldoDatatable';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';
////import AllaSvgikoner from 'Svgikoner';

import addPageAsWidget from 'ssoAddPageAsWidget';


//------------------------------------------------------------------------------------------------------------------------------

// Använd dessa Vue plugins:
Vue.use(ssoFiltreraDatatable);
Vue.use(ssoTogglaRaderIDatatable);

window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.
window.ssoPersaldo = window.ssoPersaldo || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Fixa till sidans mermeny, så den är av rätt class type:
window.ssoPersaldo.sidansMermenyConfig =
	euiPopUpMenyClasses.menyConfig.castFrom(window.ssoKontoutdrag.sidansMermenyConfig, { castAlsoNestedObjectsAndArrayValues: true });		// "casta" till rätt typ, inkl alla nästade underobjekt/arrayvärden.


// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.

//##############################################################################################################################

//console.group('Skapa Vue-appen');
//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Lokalt registrerade komponenter
	components: {
		euiPanelyta,
		euiMermeny,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		tabellen: null,		// Initialt så. null betyder 'ännu inte satt'

		widgets: window.ssoKontoutdrag.widgets,		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)
		radtexterInaktiverad: window.ssoKontoutdrag.radtexterInaktiverad,

		sidansMermenyConfig: window.ssoKontoutdrag.sidansMermenyConfig,		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)

		menyManadConfig: undefined,		// Sätts i lifecycle hook created, nedan

		selectedMonthId: window.ssoKontoutdrag.selectedMonthId,
		allaPerioderText: window.ssoKontoutdrag.allaPerioderText,

		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		kontonr: Object.freeze(window.ssoKontoutdrag.kontonr),


		// Ytterligare data finns i ssoStateStore!
	},

	computed: {
	},

	watch: {
	},

	methods: {
			onMenyalternativValt({ eventId, eventData }) {
				switch (eventId) {
					case 'addPageAsWidget':
						{
							console.log('addPageAsWidget', eventId, eventData);

							const toPageId = eventData;		// Enkom för tydlighet.

							addPageAsWidget(this, {
								toPageId: toPageId,
								elementName: 'kontoutdragwidget',
								parameters: this.kontonr,
								settings: ''
							});

							break;
						}
				}
			}
	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'persaldo';
	},


	mounted() {
		console.time('#TIMING: initieraDataTable');	// Todo: TEMP!!!
		this.tabellen = ssoPersaldoDatatable.initiera(window.ssoPersaldo.dataSet);
		console.timeEnd('#TIMING: initieraDataTable');	// Todo: TEMP!!!

		SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');


		this.$nextTick(function () {
		})
	},

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
//console.groupEnd('Skapa Vue-appen');

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
